<template>
	<section class="main-content rooms-section">
		<contentblock v-for="(room, index) in items" :key="room.pageID" :index="index">
			<template #contentblock-content>
				<h2>{{ room.title || room.header }}</h2>
				<div v-parse-links v-html="room.content" />
				<div class="room-icons">
					<div v-for="facility in room.facilities" :key="facility.id" class="icon-holder">
						<font-awesome-icon :icon="`fal fa-${facility.icon}`" size="1x" />
						<span>{{ facility.content }}</span>
					</div>
				</div>
				<nuxt-link :to="localePath(`/${room.filename}`)" class="button button-no-fill">
					{{ defaults[locale].rooms.view }}
				</nuxt-link>
				<book-button :roomid="room.bookingID" class="button button-cta">
					<span>{{ defaults[locale].rooms.book }}</span>
				</book-button>
			</template>
			<template #contentblock-image>
				<nuxt-link :to="localePath(`/${room.filename}`)">
					<picture>
						<source :srcset="room.imageOverviewWebp" type="image/webp" />
						<source :srcset="room.imageOverview" />
						<img loading="lazy" :src="room.imageOverview" :alt="room.imageOverviewAlt" class="object-fit" />
					</picture>
				</nuxt-link>
			</template>
		</contentblock>
	</section>
</template>

<script setup>
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchDefaults();

defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.rooms-section {
	padding: 0;
}

.room-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0 0 40px;
}

.icon-holder {
	color: $cta-color;
	width: 49%;
	margin: 10px 0;
}

.icon-holder i,
.icon-holder svg {
	margin: 0 5px 0 0;
}

.room-info {
	padding: 0 0 50px;

	.row {
		padding: 50px 30px;
	}
}

.row-header {
	padding-bottom: 50px;
	max-width: 1000px;
}

@media (max-width: 1080px) {
	.icon-holder {
		width: 49%;
	}
}

@media (max-width: 920px) {
	.icon-holder {
		width: 49%;
	}
}

@media (max-width: 680px) {
	.icon-holder {
		width: 99%;
	}
}
</style>
